import React from 'react';
import PropTypes from 'prop-types';
import { BlockStack, Box, Text } from '@shopify/polaris';
import { CardTile, STAR_CSS } from './VskPreview';

const FRAME_CSS = `
.star-preview { display: flex; overflow-x: auto; }
/* Without safe, a child wider than the box overflows both sides and the left half is unreachable. */
.star-preview { justify-content: safe center; }
.star-preview .star-card-frame { width: 306px; height: 124px; }
.star-preview .star-card-frame > * { height: 100%; box-sizing: border-box; }
`;

const CardPreview = ({ values }) => (
  <BlockStack gap="200">
    <Text as="span" variant="bodySm" tone="subdued">Swatch King → Partner apps</Text>

    <Box background="bg-surface-secondary" padding="300" borderRadius="200">
      <div className="star-preview star-vsk">
        <style>{STAR_CSS + FRAME_CSS}</style>

        <div className="star-card-frame">
          <CardTile values={values} />
        </div>
      </div>
    </Box>
  </BlockStack>
);

CardPreview.propTypes = { values: PropTypes.object.isRequired };

export default CardPreview;
